import {
  ActivityItem,
  Checkbox,
  CommandBarButton,
  Facepile,
  IActivityItemProps,
  IComboBox,
  IComboBoxOption,
  IContextualMenuProps,
  IFacepilePersona,
  IIconProps,
  Label,
  Link,
  Panel,
  PanelType,
  Persona,
  PersonaPresence,
  PersonaSize,
  Stack,
  VirtualizedComboBox,
  divProperties,
  mergeStyleSets,
} from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { ComboBoxIDS } from "../../../components/generic/ComboBoxIDS";
import { useComboModeloEquipos } from "../../../hooks/combosHooks/useComboModeloEquipos";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import { IPersonaEquipo } from "../../../Interfaces/IListaVerificacion";
import { useAsignacionModeloEquipo } from "../../../hooks/useAsignacionModeloEquipo";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import {
  IAsignarRol,
  ICrearCuenta,
  ICuentaById,
  IItemCheckboxBaseDTO,
  IItemComboRolesDTO,
  IUserById,
} from "../../../Interfaces/IUsuario";
import usuarioServicio from "../../../services/usuarioService";
import axios from "axios";
import { IException, IItemComboBaseDTO } from "../../../Interfaces/base/IBase";
import { IResponsePost } from "../../../Interfaces/base/IResponse";
import AuthenticationService from "../../../services/Authentication/AuthenticationService";
import { CLAIM_CUSTOMER_ID } from "../../../utils/helpers/roleHelpers";
const classNames = mergeStyleSets({
  exampleRoot: {
    marginTop: "20px",
  },
  nameText: {
    fontWeight: "bold",
  },
});

interface IPanelAsignarCuenta {
  isOpen: boolean;
  onDismiss: () => void;
  usuarioId: string | undefined;
  onRenderTable: () => void;
}
export const PanelAsignarCuenta = (props: IPanelAsignarCuenta) => {
  const addIcon: IIconProps = { iconName: "Contact" };

  const [rolesCombo, setRolesCombo] = useState<IItemCheckboxBaseDTO[]>([]);

  const [dataUser, setDataUser] = useState<IItemComboBaseDTO[]>([]);
  const [itemSelected, setItemselected] = useState<ICrearCuenta>({
    usuarioId: props.usuarioId!,
    cuentaId: "",
  });

  const [isSend, setIsSend] = useState(false);

  const [disableForm, setDisableForm] = useState<boolean>(true);
  const [isContenedor, setIsContenedor] = useState(false);
  const [isSaccesful, setIsSaccesful] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [isEnviado, setIsEnviado] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesful(false);
      getAllCuentas();
    }
  }, [props.isOpen]);

  const getAllCuentas = () => {
    var customerId = AuthenticationService.getInfoToken(CLAIM_CUSTOMER_ID);
    if (customerId) {
      usuarioServicio
        .getAllCuentas(customerId)
        .then((res) => {
          if (res.status == 200) {
            const comboData = res.data.map((x) => ({
              key: `${x.id}`,
              text: `${x.nombre}`,
            }));
            setDataUser(comboData);
          }
        })
        .catch((e) => {
          if (axios.isCancel(e)) {
            
          } else {
            console.error("Error en la solicitud:", e?.message);
          }
        });
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="ContactInfo"
          subTextHeader=""
          textHeader="Asignar Cuenta"
          fontSize="30px"
        />
      </>
    ),
    []
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Asignar"
          texto2={"Salir"}
          disableButton={disableForm}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            limpiarResponse();
          }}
        />
      </>
    ),
    [disableForm]
  );

  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: "emailMessage",
        text: "Email message",
        iconProps: { iconName: "Mail" },
      },
      {
        key: "calendarEvent",
        text: "Calendar event",
        iconProps: { iconName: "Calendar" },
      },
    ],
  };

  //   const onChange = React.useCallback(
  //     (
  //       ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
  //       checked?: boolean
  //     ): void => {
  //       const roles = [...rolesCombo];
  //       roles[index].isChecked = !roles[index].isChecked;
  //       setRolesCombo(roles);
  //     },
  //     []
  //   );

  const _confirmar = () => {
    setIsSend(true);
    setIsContenedor(true);
    setDisableForm(true);
    usuarioServicio
      .asignarCuenta(itemSelected)
      .then((res) => {
        if (res.status == 200) {
          setIsSend(false);
          setIsSaccesful(true);

          if (res.data == "ok") {
            setIsEnviado(true);
          } else {
            setMensajeError(res.data);
            setIsError(true);
          }
          props.onRenderTable();
        }
      })
      .catch((e: IException) => {
        if (e.response.status == 403) {
          setIsSaccesful(true);
          setIsSend(false);

          setIsError(true);
          setMensajeError("Usuario no Autorizado");
        } else {
          setIsError(true);
          setMensajeError("Error en la operación");
        }
      });
  };

  const limpiarResponse = () => {
    setIsSend(false);
    setIsSaccesful(false);
    setIsError(false);
    setItemselected({ ...itemSelected, cuentaId: "" });
    setDisableForm(true);
    setIsContenedor(false);
    setMensajeError("");
    setIsEnviado(false);
    props.onDismiss();
  };

  const onClick = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number
  ) => {
    if (event != undefined && event != null) {
      setItemselected({ ...itemSelected, cuentaId: option?.key.toString()! });
    }
  };

  const validarForm = () => {
    if (itemSelected == null) setDisableForm(true);
    if (itemSelected !== null) {
      if (itemSelected.cuentaId && itemSelected.usuarioId) {
        setDisableForm(false);
      } else {
        setDisableForm(true);
      }
    }
  };

  useEffect(() => {
    validarForm();
  }, [itemSelected, props.isOpen]);

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={limpiarResponse}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
      isLightDismiss={true}
    >
      <>
        <br />
        {/* <pre>{JSON.stringify(itemSelected, null, 2)}</pre>
        <pre>{JSON.stringify(disableForm, null, 2)}</pre> */}

        {isEnviado == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: "Registro Exitoso", codigoMensaje: 1 }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: mensajeError, codigoMensaje: 3 }}
          />
        )}

        <div hidden={isContenedor}>
          <div
            style={{
              width: "100%",
              // border: "solid 1px red",
              marginTop: "20px",
              position: "relative",
            }}
          >
            <CommandBarButton
              style={{
                margin: "auto",
                //   border: "solid 1px green",
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
              iconProps={addIcon}
              text="Seleccione la cuenta"
              disabled={false}
              checked={false}
            />
          </div>
          <br />
          <br />

          <VirtualizedComboBox
            defaultSelectedKey="547"
            label=""
            allowFreeform
            autoComplete="on"
            options={dataUser}
            // dropdownMaxWidth={200}
            useComboBoxAsMenuWidth
            // onChange={onchange}
            onItemClick={onClick}

            // styles={}
          />
        </div>
      </>
    </Panel>
  );
};
